@if (inited) {
  <div class="center-child mb-2">
    <p-button icon="fas fa-arrow-left" (onClick)="prevWeek()" [disabled]="date == calendarWeeksGui[0].value">
    </p-button>
    <p-select class="mr-1 width300" id="week" [options]="calendarWeeksGui" [(ngModel)]="date" (ngModelChange)="changeWeek()">
    </p-select>
    <p-button icon="fas fa-arrow-right" (onClick)="nextWeek()" [disabled]="date == calendarWeeksGui[calendarWeeksGui.length - 1].value">
    </p-button>
    <p-tag class="week-tag" [value]="isBWeek ? 'B-Woche' : 'A-Woche'"></p-tag>
  </div>
  <p-table class="p-datatable-gridlines" [value]="cells">
    <ng-template pTemplate="header">
      <tr>
        <th>Stunde</th>
        @for (index of rowIndexes; track index) {
          <th [style.width]="(100 / rowIndexes.length) + '%'">{{weekDayNames[index]}} {{_Dates.format(_Dates.add(date, 'day', index), 'dd.mm')}}</th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-index="rowIndex">
      <tr [pSelectableRow]="row">
        <td>{{index + 1}}</td>
        @for (index of rowIndexes; track index) {
          <td [class.shade]="row[index].isHoliday" [class.cell-free]="!row[index].isHoliday && row[index].getStatus() == ''" [class.mouse-pointer]="!isFuture && !row[index].isHoliday && row[index].getStatus() != '' && row[index].getStatus() != 'slash'" (click)="clickLesson(row[index])">
            @if (!row[index].isHoliday) {
              <div *ngVar="row[index].getStatus() as status">
                {{row[index].getTitle()}}
                @if (row[index].getSubstituteDomain() != null) {
                  <span class="substitute-domain">({{row[index].getSubstituteDomain()}})</span>
                }
                @if (status != '' && status != 'A') {
                  <i [class]="'cell-status fas fa-' + status" [pTooltip]="getStatusToolTip(status)"></i>
                }
                @if (status == 'A') {
                  <span class="cell-status cell-status-text">A</span>
                }
              </div>
            }
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
  <p-dialog header="Auswahl der Unterrichtseinheit" [(visible)]="displayModalSelectLesson" [modal]=true [style]="{width: '700px', height: '400px'}" [baseZIndex]="10000"
    [draggable]=false [resizable]=false>
    <div class="grid">
      @for (entry of modalSelectLessonEntries; track entry) {
        <p-card class="col-12 mouse-pointer" [class.cell-free]="entry.status == ''" [class.mouse-pointer]="entry.status != ''" (click)="modalSelectSlot(entry)">
          {{entry.domain}}
          @if (entry.getSubstituteDomain() != null) {
            <span class="substitute-domain">({{entry.getSubstituteDomain()}})</span>
          }
          @if (entry.status != '') {
            <i [class]="'cell-status fas fa-' + entry.status"></i>
          }
        </p-card>
      }
    </div>
    <p-footer>
      <button type="button" pButton icon="fas fa-times" severity="secondary" (click)="displayModalSelectLesson=false" label="Abbrechen"></button>
    </p-footer>
  </p-dialog>
}
